module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"timezone":{"local":"Times displayed in your time zone","calendar":"Times displayed in your calendar\u0027s time zone"},"confirm":"Confirm","emptyAvailability":{"title":"No availability for the selected date","subtitle":"Try selecting another date"},"availabilityLoadError":"Something went wrong while loading availability, please try again."}}')
  delete Component.options._Ctor
}
